import React from "react";
import "./Css/Gallary.css";
import img1 from "./Images/ruksharopan2.jpg";
import img2 from "./Images/ruksharopan1.jpg";
import img3 from "./Images/Ruksharopan4.jpg";
import img4 from "./Images/Ruksharopan3.jpg";


export default function Ruksharopan() {
  return (
    <section className="school-social-section">
        
      <h2 className="school-social-title">गावामध्ये वृक्षारोपण कार्यक्रम

</h2>

      <div className="school-social-grid">

        {/* Left Big Image */}
        <img src={img1} alt="event" className="school-img big-img" />

        {/* Right Image Grid */}
        <div className="right-grid">

          {/* Row 1 - Two Small Images */}
          <div className="top-small-row">
            <img src={img2} alt="event" className="school-img small-img" />
            <img src={img3} alt="event" className="school-img small-img" />
          </div>

          {/* Middle Wide Image */}
          <div className="middle-wide-row">
            <img src={img4} alt="event" className="school-img wide-img" />
            
          </div>
        </div>
      </div>

    </section>
  );
}
